import { IconButton, Tooltip, useTranslate } from '@prenuvo/halo';
import { ArrowUpright } from '@prenuvo/halo-icon';

import { useBroadcastChannel } from '@/core/broadcast-channel';

import { PatientDocLink } from '../../patient-docs-side-panel.model';

interface ExternalDocumentLinkProps {
  link: PatientDocLink;
}

export function ExternalDocumentLink({ link: { url } }: ExternalDocumentLinkProps) {
  const { onOpenTrackedWindow } = useBroadcastChannel();
  const translate = useTranslate();

  return (
    <Tooltip
      content={translate('FCT.PATIENT_DOCS.SIDE_PANEL.DOCUMENTS.ACTIONS.TOOLTIP')}
      side="bottom"
    >
      <IconButton
        aria-label={`View Document with url of ${url} in new tab`}
        icon={ArrowUpright}
        onClick={() => onOpenTrackedWindow(url, '_blank')}
        size="xs"
        variant="text"
      />
    </Tooltip>
  );
}
